// extracted by mini-css-extract-plugin
export default {"CookieSettings":"CookieSettings_NEcOV"};